import translation_fr from '../lang/fr.json';
import translation_en from '../lang/en.json';

export function translate(lang) {
    switch (lang) {
        case 'fr':
            return translation_fr;
        case 'en':
            return translation_en;
        default:
            return translation_en;
    }
}


//////////////////
// WEBPACK FOOTER
// ./static/js/translate.js
// module id = null
// module chunks = 